<template>
  <transition name="modal">
      <div class="modal-mask">
          <div class="modal-container modal-container__video">

            <div class="modal-header">
              <slot name="header">
                <h2>{{ videoDetails.title }}</h2>
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
                <div class="video-wrapper">

                  <div class="redactor" v-html="videoDetails.summary"></div>
                  <div class="responsive-video">
                    <iframe :src="embedUrl+'?autoplay=1&title=0&byline=0&portrait=0'"  frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                  </div>
                </div>
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                <button @click.prevent="$emit('close')" style="float:right">
                  <span style="color:red; font-size:0.8em">Close</span>
                </button>
              </slot>
            </div>
        </div>
      </div>

  </transition>

</template>

<script>
export default {
  props: ['videoDetails'],
  data(){
    return {
      loading:false,
    }
  },
  computed: {
    embedUrl(){
        var pattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
        var replacement = 'https://player.vimeo.com/video/$1';
        return this.videoDetails.url.replace(pattern,replacement);
    }
  },
}

</script>

<style lang="scss">
  .responsive-video {
    position: relative;
    display: block;
    height: 0;
    /* 56.25% is 16 by 9 aspect ratio */
    padding: 0 0 56.25% 0;
    overflow: hidden;
      iframe {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }
</style>